import { dashboardApi } from '@/services/dashboardApi';
import { BACKEND_URL } from '@/config/api';

// Oportunidades del club (backend: routes/opportunities.py, prefijo /api/dashboard/opportunities)
const get = (path) => dashboardApi._fetch(`/opportunities${path}`);
const send = (method, path, body) => dashboardApi._fetch(`/opportunities${path}`, {
  method,
  ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
});
const enc = encodeURIComponent;

export const opportunitiesApi = {
  list: () => get(''),
  get: (id) => get(`/${enc(id)}`),
  interest: (id, data) => send('POST', `/${enc(id)}/interest`, data),

  // Admin
  adminList: () => get('/admin/all'),
  adminCreate: (data) => send('POST', '/admin', data),
  adminUpdate: (id, data) => send('PUT', `/admin/${enc(id)}`, data),
  adminDelete: (id) => send('DELETE', `/admin/${enc(id)}`),
  adminInterests: (oppId) => get(`/admin/interests/list${oppId ? `?opportunity_id=${enc(oppId)}` : ''}`),
  adminInterestStatus: (id, status) => send('PATCH', `/admin/interests/${enc(id)}`, { status }),
  adminImport: () => send('POST', '/admin/import-fhc'),
  adminUploadImage: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const token = sessionStorage.getItem('dashboard_token');
    const res = await fetch(`${BACKEND_URL}/api/dashboard/opportunities/admin/images`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const d = data.detail;
      throw new Error(Array.isArray(d) ? d.map(x => x.msg).join(' · ') : (d || 'No se ha podido subir la imagen'));
    }
    return data;
  },
};

export const STATUSES = ['Próximamente', 'Ventana abierta', 'Ventana cerrada', 'En ejecución', 'En venta', 'Liquidada'];

export const STATUS_STYLE = {
  'Ventana abierta': 'bg-[#060d1b]/85 text-emerald-300 border-emerald-500/40',
  'Próximamente': 'bg-[#060d1b]/85 text-purple-300 border-purple-500/40',
  'Ventana cerrada': 'bg-[#060d1b]/85 text-gray-300 border-gray-500/40',
  'En ejecución': 'bg-[#060d1b]/85 text-blue-300 border-blue-500/40',
  'En venta': 'bg-[#060d1b]/85 text-[#e3c87a] border-[#c9a84c]/50',
  Liquidada: 'bg-[#060d1b]/85 text-gray-400 border-gray-500/40',
};

// URL absoluta de una foto (el backend devuelve rutas /api/public/...)
export const imgUrl = (u) => (!u ? null : u.startsWith('http') ? u : `${BACKEND_URL}${u}`);

// 1.000 € / 2.608.153 € / 10.000 $ (separador de miles también en cifras de 4 dígitos)
export const money = (v, currency = 'EUR') => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v).toLocaleString('de-DE', { maximumFractionDigits: 0 });
  return currency === 'USD' ? `${n} $` : `${n} €`;
};
export const pct = (v) => (v === null || v === undefined ? '—' : `${Number(v).toLocaleString('de-DE', { maximumFractionDigits: 1 })} %`);

export const opTitle = (o) => (o.code ? `Operación ${o.code} · ${o.name}` : o.name);
export const opPlace = (o) => [o.city, o.region].filter(Boolean).join(' · ');

export function returnFigure(o) {
  if (o.gross_return_min !== null && o.gross_return_min !== undefined) {
    const v = o.gross_return_max ? `${pct(o.gross_return_min).replace(' %', '')} – ${pct(o.gross_return_max)}` : pct(o.gross_return_min);
    return { label: 'Rentabilidad bruta total estimada', value: v };
  }
  if (o.annual_yield !== null && o.annual_yield !== undefined) return { label: 'Rendimiento de explotación', value: `${pct(o.annual_yield)} anual` };
  return null;
}

export function saleFigure(o) {
  if (!o.sale_price_min) return null;
  const cur = o.currency;
  return {
    label: o.sale_label || (o.sale_price_max ? 'Rango de venta estimado' : 'Precio estimado de venta'),
    value: o.sale_price_max ? `${money(o.sale_price_min, cur)} – ${money(o.sale_price_max, cur)}` : money(o.sale_price_min, cur),
  };
}

export const DISCLAIMER = 'Los datos, objetivos y ejemplos de esta ficha tienen carácter exclusivamente informativo y orientativo. '
  + 'No constituyen promesa, garantía ni expectativa contractual de rendimiento. Las operaciones inmobiliarias están sujetas a '
  + 'condiciones de mercado y riesgo de pérdida. Cada socio toma sus decisiones de aportación bajo su propia responsabilidad '
  + 'y tras la formación correspondiente.';
